import { hospitalpasswordActions } from '../../../../actions/user/hospital/Account/resetPassword';

const initialState = {
  loading: false,
  error: null,
  successMessage: null,
  isVerified: false
};

const hospitalPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case hospitalpasswordActions.RESET_PASSWORD.REQUEST:
    case hospitalpasswordActions.CONFIRM_RESET_PASSWORD.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        successMessage: null
      };

    case hospitalpasswordActions.RESET_PASSWORD.SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        successMessage: action.payload.message,
        isVerified: action.payload.isVerified // Ensure verification status updates
      };

    case hospitalpasswordActions.CONFIRM_RESET_PASSWORD.SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        successMessage: action.payload.message,
        isVerified: false // Reset verification state after final password update
      };

    case hospitalpasswordActions.RESET_PASSWORD.FAILURE:
    case hospitalpasswordActions.CONFIRM_RESET_PASSWORD.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        successMessage: null // Clear any previous success messages
      };

    default:
      return state;
  }
};

export default hospitalPasswordReducer;
